import type { ComposerTranslation } from 'vue-i18n';
import { groupBy, isNil } from 'lodash-es';
import type { Airflow } from '@aviata/platform-types';

import { baggageLib } from '@/entities/baggage';

import { FF_SERVICE_STATE } from '../config';

export function mapServicesByState(
  services: Airflow.FareFamily.Description.Entity[],
): Airflow.FareFamily.Description.Entity[] {
  const grouped = groupBy(services, 'state');

  return [
    ...(grouped[FF_SERVICE_STATE.INCLUDED] || []),
    ...(grouped[FF_SERVICE_STATE.CHARGEABLE] || []),
    ...(grouped[FF_SERVICE_STATE.NOT_OFFER] || []),
  ];
}

export function mapServiceStateToTitle({
  type,
  state,
  value = '',
  t,
}: {
  type: string;
  state: string;
  value?: string;
  t: ComposerTranslation;
}) {
  const service = type
    .toLowerCase()
    .replace(/([-_][a-z])/g, group =>
      group.toUpperCase().replace('-', '').replace('_', ''),
    );
  const stateKey = state
    .toLowerCase()
    .replace(/\s+([a-z])/g, (match, group) => group.toUpperCase());

  return t(`fareFamily.services.${service}_${stateKey}`, {
    value: value ?? t('fareFamily.services.unknown'),
  });
}

export function getLuggageServiceState(
  handLuggageList: (Airflow.Segment.HandLuggageEntity | null)[],
) {
  const handLuggage = handLuggageList.map(hl => hl?.value || null);

  // edge case where hand_luggage is not present in any segment
  if (handLuggage.length === 0) {
    return FF_SERVICE_STATE.UNKNOWN;
  }

  // hand luggage must cover all passengers
  if (handLuggage.some(s => isNil(s) || s === 0)) {
    return FF_SERVICE_STATE.NOT_OFFER;
  }

  return FF_SERVICE_STATE.INCLUDED;
}

export function getBaggageServiceState(
  rawBaggage: Airflow.Segment.BaggageEntity | null,
) {
  if (isNil(rawBaggage)) {
    return FF_SERVICE_STATE.UNKNOWN;
  }

  const baggage = rawBaggage ? baggageLib.parse(rawBaggage) : baggageLib.none;

  if (baggage.count === 0) {
    return FF_SERVICE_STATE.NOT_OFFER;
  }

  return FF_SERVICE_STATE.INCLUDED;
}

export { createFareFeatures, type FareFeature } from './fare-features';
